/**
 * The TAPI phone integration opens `/integrations/tapi/{CALLERNUM}`, so the
 * caller's phone number ends up in URL-bearing analytics properties
 * (`$current_url`, `$pathname`, `$referrer`). That number is personal data and
 * must not be stored in PostHog.
 *
 * Replaces the phone-number segment with a `:phone` placeholder in both full
 * URLs and bare pathnames, rewriting up to the next `?` or `#` so query strings
 * and hashes are preserved. The number itself is matched greedily *including any
 * slashes* — some caller numbers arrive slashed (e.g. "1234/56"), and masking
 * only up to the first `/` would leave the tail (`56`) exposed. Strings without
 * the TAPI path (and the bare instructions page `/integrations/tapi/`, which has
 * no number) are returned unchanged.
 */
export function maskTapiPhoneUrl(value: string): string {
    return value.replaceAll(/(\/integrations\/tapi\/)[^?#]+/g, '$1:phone');
}
